import React from "react"
import { Link } from "react-router-dom"
import { BackButton } from "../../../Assets"

interface GoBackProps {
  link: string
  className?: string
}

const GoBack = ({ link, className }: GoBackProps) => (
  <Link to={link} className="hover:no-underline">
    <div className="flex justify-start items-center">
      <img src={BackButton} alt="back" className="w-5 h-5" />
      <p
        className={` ${className} ml-2 text-assetize-dark font-latoBold font-[18px] text-md hover:text-assetize-dark-text`}
      >
        Back
      </p>
    </div>
  </Link>
)

export default GoBack
